"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var style_1 = require("../../style");
var styles = {
    container: function (radius) { return react_1.css({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: style_1.pxToRem(radius * 2),
        height: style_1.pxToRem(radius * 2),
    }); },
    progress: function (state, offSet, circumference) {
        return function (theme) { return react_1.css({
            strokeDasharray: circumference + " " + circumference,
            strokeDashoffset: offSet,
            stroke: theme.color[state].DEFAULT,
            animation: turnAnimation(offSet, circumference) + " 1.0s ease-in-out",
            transform: 'rotate(-90deg)',
            transformOrigin: '50% 50%',
        }); };
    },
    base: function (circumference) { return function (theme) { return react_1.css({
        strokeDasharray: circumference + " " + circumference,
        stroke: theme.color.GRAY.LIGHT_3,
    }); }; },
    text: function (strokeWidth) { return react_1.css({
        fontSize: style_1.pxToRem(strokeWidth * 2),
        fontWeight: 600,
    }); },
};
var turnAnimation = function (offSet, circumference) { return react_1.keyframes({
    from: { strokeDashoffset: circumference },
    to: { strokeDashoffset: offSet },
}); };
var circleSize = {
    xs: { radius: 16, strokeWidth: 2 },
    sm: { radius: 24, strokeWidth: 4 },
    md: { radius: 32, strokeWidth: 4 },
    lg: { radius: 40, strokeWidth: 6 },
    xl: { radius: 80, strokeWidth: 8 },
};
var ProgressCircle = function (_a) {
    var progress = _a.progress, _b = _a.state, state = _b === void 0 ? 'PRIMARY' : _b, _c = _a.size, size = _c === void 0 ? 'lg' : _c, text = _a.text;
    var _d = circleSize[size], radius = _d.radius, strokeWidth = _d.strokeWidth;
    var normlizedRadius = radius - strokeWidth;
    var circumference = 2 * Math.PI * normlizedRadius;
    var offSet = circumference * (1 - (progress / 100));
    return (react_1.jsx("svg", { css: styles.container(radius) },
        react_1.jsx("circle", { css: styles.base(circumference), fill: "none", strokeWidth: strokeWidth, strokeLinecap: "round", cx: style_1.pxToRem(radius), cy: style_1.pxToRem(radius), r: normlizedRadius }),
        react_1.jsx("circle", { css: styles.progress(state, offSet, circumference), fill: "none", strokeWidth: strokeWidth, strokeLinecap: "round", cx: style_1.pxToRem(radius), cy: style_1.pxToRem(radius), r: normlizedRadius }),
        text ? react_1.jsx("text", { css: styles.text(strokeWidth), x: style_1.pxToRem(radius - strokeWidth * 1.5), y: style_1.pxToRem(radius + (strokeWidth / 2)) },
            progress,
            "%") : undefined));
};
exports.default = ProgressCircle;
